export default __webpack_public_path__ + "static/media/Hair_10_M_C5.e0c7f496.svg";